import { IPanelActualizarUbi } from "../actualizarUbi/PanelActualizarUbi";
import { Warning24Filled } from "@fluentui/react-icons";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { Body1, makeStyles } from "@fluentui/react-components";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";
import { useCallback } from "react";
import { UsePanelOcultoUbicacion } from "./UsePanelOcultoUbicacion";

const useStyles = makeStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignContent: "center",
      top: "100%",
      alignItems: "center",
    },
  
    warning: {
      color: " #eaa300",
      width: "60px",
      height: "60px",
    },
  });
export const PanelOcultoUbicacion=(props:IPanelActualizarUbi)=>{
    const styles = useStyles();
    const {request,setRequest,putEditarCatalogo,loading,reset,mensaje,status} = UsePanelOcultoUbicacion(props)
    const onRenderFooter = useCallback(
        () => (
          <>
            <PanelFooter
              texto={props.item.esOculto?"Habilitar":"Ocultar"}
              texto2={"Salir"}
              onClick={putEditarCatalogo}
              onDismiss={() => {
                reset()
              }}
            />
          </>
        ),
        [request]
      );
    return (
        <PanelDrawer
          isOpen={props.isOpen}
          onDismiss={reset}   
          textHeader={props.item.esOculto?"Habilitar Elemento":"Ocultar Ubicación"}
          status={status}
          mensaje={mensaje}
          loading={loading}
          onRenderFooter={onRenderFooter}
        >
         <>
                    <div className={styles.container}>
                      <div>
                        <Warning24Filled className={styles.warning} />
                      </div>
                      <div>
                        <Body1>
                          ¿Desea 
                             {props.item.esOculto?" habilitar":" ocultar"} la Ubicación: {props.item.nombre}?
                        </Body1>
                      </div>
                    </div>
                  </>
       </PanelDrawer>
    )
}